import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { siteConfig } from "../siteConfig";

/*
  GoHighLevel survey embed — to swap to a different client's survey,
  replace SURVEY_SRC with the iframe src from their embed code.
*/
const SURVEY_SRC = "https://links.soardigital.co/widget/survey/AzZJEHtjBbfFbAg0gqAn";
const SURVEY_ID = "AzZJEHtjBbfFbAg0gqAn";

/* Background photo — kept distinct from the homepage hero/CTA image */
const BG_IMAGE =
  siteConfig.services.find((s) => s.slug === "commercial-pressure-washing")?.image ||
  siteConfig.cta.image;

const PLACEHOLDER_HEIGHT = 560;

// Minimum time to keep the loading state visible, so it can't flash by
// unnoticed even if the iframe reports "loaded" almost instantly.
const MIN_LOADING_MS = 1400;

const ReviewSurveyPage = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);
  const loaded = iframeLoaded && minTimeElapsed;

  useEffect(() => {
    if (document.querySelector('script[src="https://links.soardigital.co/js/form_embed.js"]')) return;
    const script = document.createElement("script");
    script.src = "https://links.soardigital.co/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setMinTimeElapsed(true), MIN_LOADING_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center pt-32 pb-20 px-5 overflow-hidden">
      {/* Background photo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />
      <div className="absolute inset-0" style={{ background: "rgba(4,12,4,0.80)" }} />

      <div className="relative z-10 text-center mb-10 max-w-xl">
        <p
          className="text-xs font-black uppercase tracking-widest mb-3"
          style={{ color: siteConfig.colors.primary }}
        >
          Share Your Experience
        </p>
        <h1
          className="font-display font-black text-white leading-tight mb-4"
          style={{ fontSize: "clamp(2.2rem,5vw,3.5rem)" }}
        >
          How Did We Do?
        </h1>
        <p className="text-white/60 text-base">
          Your feedback means everything to us. It takes less than 30 seconds.
        </p>
      </div>

      <div
        className="relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-xl overflow-hidden"
        style={{ minHeight: loaded ? undefined : PLACEHOLDER_HEIGHT }}
      >
        {/* Loading overlay — sits on its own layer, independent of the iframe's
            own sizing (GHL's embed script controls the iframe's height directly
            via the DOM, so we can't rely on the iframe to size this wrapper). */}
        {!loaded && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-white">
            <Loader2 className="w-7 h-7 animate-spin" style={{ color: siteConfig.colors.primary }} />
            <p className="text-sm font-semibold text-gray-500">Loading survey...</p>
          </div>
        )}
        <iframe
          src={SURVEY_SRC}
          style={{
            border: "none",
            width: "100%",
            display: "block",
            opacity: loaded ? 1 : 0,
            transition: "opacity 0.35s ease",
          }}
          scrolling="no"
          id={SURVEY_ID}
          title="survey"
          onLoad={() => setIframeLoaded(true)}
        />
      </div>
    </section>
  );
};

export default ReviewSurveyPage;
